
(function documentContainerModuleDefinition() {

    'use strict';

    angular.module('DocumentContainer', ['ui.router', 'ui.tree', 'ui.treeExtend', 'ui.bootstrap.modal', 'Config', 'Entities',
                                         'ClickOnce', 'FileDownloader', 'Actions', 'TwainCapture'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function documentContainerConfig(config, $stateProvider, loginProvider) {

                $stateProvider.state('document-container-find', {
                    url: "/MyDocumentContainer/List",
                    templateUrl: config.resourceUrl('/views/document-container/my-list.html'),
                    controller: 'DocumentContainerFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER READ')
                                        .or('DOCUMENTCONTAINER WRITE')
                });

                $stateProvider.state('document-container-add', {
                    url: '/DocumentContainer/Add',
                    templateUrl: config.resourceUrl('/views/document-container/add.html'),
                    controller: 'DocumentContainerAddController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER WRITE')
                });

                $stateProvider.state('document-container-add-digitalizing', {
                    url: '/DocumentContainer/AddDigitalizing',
                    templateUrl: config.resourceUrl('/views/document-container/add-digitalizing.html'),
                    controller: 'DocumentContainerAddDigitalizingController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER WRITE')
                                        .and('DOCUMENT MASSIVE DIGITALIZATION')
                                        .and('DOCUMENT WRITE')
                });

                $stateProvider.state('document-container-modify', {
                    url: '/DocumentContainer/Modify/{id}',
                    templateUrl: config.resourceUrl('/views/document-container/modify.html'),
                    controller: 'DocumentContainerModifyController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER WRITE')
                });

                $stateProvider.state('document-container-detail', {
                    url: '/DocumentContainer/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/document-container/detail.html'),
                    controller: 'DocumentContainerDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER READ')
                                        .or('DOCUMENTCONTAINER WRITE')
                });

                $stateProvider.state('document-container-associate', {
                    url: '/DocumentContainer/Associate',
                    templateUrl: config.resourceUrl('/views/document-container/associate.html'),
                    controller: 'DocumentContainerAssociateController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER WRITE')
                });

                $stateProvider.state('document-container-advanced-find', {
                    url: '/DocumentContainer/Find',
                    templateUrl: config.resourceUrl('/views/document-container/list.html'),
                    controller: 'DocumentContainerAdvancedFindController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER READ').or('DOCUMENTCONTAINER WRITE')
                });

                $stateProvider.state('document-container-detail-from-doc', {
                    url: '/Document/{docId}/DocumentContainer/Detail/{id}',
                    templateUrl: config.resourceUrl('/views/document-container/detail.html'),
                    controller: 'DocumentContainerDetailController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENTCONTAINER READ').or('DOCUMENTCONTAINER WRITE')
                });
                $stateProvider.state('share-document-container', {
                    url: "/DocumentContainer/Share/{id}",
                    templateUrl: config.resourceUrl('/views/document-container/share.html'),
                    controller: 'DocumentContainerShareController',
                    authorize: true,
                    roles:loginProvider.roleCondition('SHARE').and('DOCUMENTCONTAINER READ') || loginProvider.roleCondition('SHARE').and('DOCUMENTCONTAINER WRITE')
                });
            }
        ]);
})();